/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateAccountVerifyOtpInput = {|
  otp: string
|};
export type UpdateAccountVerifyOtpMutationVariables = {|
  input: UpdateAccountVerifyOtpInput
|};
export type UpdateAccountVerifyOtpMutationResponse = {|
  +updateAccountVerifyOtp: ?{|
    +result: ?boolean
  |}
|};
export type UpdateAccountVerifyOtpMutation = {|
  variables: UpdateAccountVerifyOtpMutationVariables,
  response: UpdateAccountVerifyOtpMutationResponse,
|};
*/


/*
mutation UpdateAccountVerifyOtpMutation(
  $input: UpdateAccountVerifyOtpInput!
) {
  updateAccountVerifyOtp(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAccountVerifyOtpPayload",
    "kind": "LinkedField",
    "name": "updateAccountVerifyOtp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateAccountVerifyOtpMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateAccountVerifyOtpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8edfbb326433909fe374036caf3d89ab",
    "id": null,
    "metadata": {},
    "name": "UpdateAccountVerifyOtpMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateAccountVerifyOtpMutation(\n  $input: UpdateAccountVerifyOtpInput!\n) {\n  updateAccountVerifyOtp(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4a0b91c7a0173c62a206257d3bbf56ab';

module.exports = node;
